import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductImportationStatusEnum } from 'src/app/Enums/ProductImportationStatusEnum';
import { ProductImportation } from 'src/app/models/Product/Import/ProductImportation.model';
import { ProductImportationService } from 'src/app/services/product/importation/product-importation.service';

@Component({
  selector: 'app-product-import-history-dialog',
  templateUrl: './product-import-history-dialog.component.html',
  styleUrls: ['./product-import-history-dialog.component.scss']
})
export class ProductImportHistoryDialogComponent implements OnInit, OnDestroy {

  private _data: ProductImportation[] = [];
  public get data() {
    return this._data.map((d) => {
      return {
        id: d.id,
        status: d.status,
        fileName: d.originalFileName,
        historyMessage: this.getMessageToShow(d.status, d.statusChangedAt),
        progress: d.progressPercentage
      }
    });
  };
  public Enum = ProductImportationStatusEnum;

  private intervalRef: NodeJS.Timer | undefined;

  constructor(
    private dialogRef: MatDialogRef<ProductImportHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public injectData: ProductImportation[] | null,
    private importService: ProductImportationService,
    private router: Router,
  ) {
    this._data = injectData ?? [];
  }

  ngOnInit(): void {
    this.getHistory();
    this.intervalRef = setInterval(() => {
      this.importService.apiGetProductImportationPaginated();
    }, 3000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalRef);
  }

  async reviewImportation(id: number) {
    await this.importService.loadProductImportation(id);
    this.importService.loadColumnMap("");
    this.dialogRef.close();
    this.router.navigate(['/product'],{skipLocationChange:false}).then(()=>{
      this.router.navigate(['/product/import/review'], {skipLocationChange: true})
    });
  }

  private async getHistory() {
    this.importService.getImportationHistory().subscribe((history) => {
      this._data = history;
    });
  }

  private getMessageToShow(status: ProductImportationStatusEnum, date: Date) {
    let msg = " ";
    switch (status) {
      case ProductImportationStatusEnum.Aborted:
        msg += "cancelado pelo usuário"
        break;
      case ProductImportationStatusEnum.Completed:
        msg += "importado com sucesso"
        break;
      case ProductImportationStatusEnum.Error:
        msg += "falha na importação"
        break;
      case ProductImportationStatusEnum.ReadingFile:
      case ProductImportationStatusEnum.Received:
      case ProductImportationStatusEnum.SavingProducts:
      case ProductImportationStatusEnum.ValidatingProducts:
        msg += "em andamento"
        return msg;
        break;
      case ProductImportationStatusEnum.ValidatedProducts:
        msg += "aguardando revisão"
        return msg;
        break;
    }

    date = new Date(date);

    msg += " às "+
      date.toLocaleTimeString("pt-BR", {hour: "2-digit", minute: "2-digit", second: undefined})+
      " de "+
      date.toLocaleDateString("pt-BR", {day: "2-digit", month: "2-digit", year: "2-digit"});

    return msg;
  }
}
